import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ModalCovered extends Vue {
  modal_class: string;
  button_compare_class = "active";
  compare_tab_class = "comparetab";
  button_repairs_class = "inactive";
  repairs_tab_class = "repairtab hide";
  drop_down_class = "mobile-compare-dropdown";

  constructor() {
    super();
    this.modal_class = "modal hide";
  }

  close() {
    this.modal_class = "modal hide";
    if (this.$route.params.dest) {
      this.$router.push({ name: this.$route.params.dest });
    } else {
      this.$router.push({ name: "home" });
    }
  }

  mounted() {
    this.modal_class = "modal show";
  }

  compareTab() {
    this.button_compare_class = "active";
    this.compare_tab_class = "comparetab";
    this.button_repairs_class = "inactive";
    this.repairs_tab_class = "repairtab hide";
  }

  repairsTab() {
    this.button_compare_class = "inactive";
    this.compare_tab_class = "comparetab hide";
    this.button_repairs_class = "active";
    this.repairs_tab_class = "repairtab";
  }

  dropDownShow() {
    if (this.drop_down_class.includes("show")) {
      this.drop_down_class = "mobile-compare-dropdown";
    } else {
      this.drop_down_class = "mobile-compare-dropdown show";
    }
  }
}
